import Dropdown, { DropdownProps } from '~/components/molecules/Dropdown';
import { withHookForm } from '~/decorators/withHookForm';

const HookFormSelectField = withHookForm<DropdownProps>(Dropdown);

export default HookFormSelectField;
